import {ReactNode, useEffect} from 'react';
import {IniErrorCode} from '../../../../../../common/shared/ini-player/IniErrorCode.enum';
import {IniExtendedErrorCode} from '../../../../../../common/shared/ini-player/IniExtendedErrorCode.enum';
import useIsLoadedIniPlayerScript from '../../../../../../common/useIsLoadedIniPlayerScript';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import {VodViewerData} from '../../../../../../graphql/generated/types';
import {useViewerInfoQuery} from '../../../../../../wrapper/viewerWrapper';
import {setIniError} from '../state/videoViewerSlice';
import {setIsViewerEndExposed} from '../state/viewerEndSlice';
import {setIsViewerMenuExposed} from '../state/viewerMenuSlice';

export interface VideoViewerFetcherHeadlessProps {
  seriesId: number;
  productId: number;
  children: ReactNode;
}

export function VideoViewerFetcherHeadless({
  seriesId,
  productId,
  children,
}: VideoViewerFetcherHeadlessProps) {
  const isLoadedIniPlayer = useIsLoadedIniPlayerScript();

  const {data, isSuccess} = useViewerInfoQuery({
    seriesId,
    productId,
  });
  const viewerData = data?.viewerData as VodViewerData;
  const vodDownloadData = viewerData?.vodDownloadData;
  const isViewerInfoFetched = isSuccess;
  const drmInfo = viewerData?.drmInfo;
  const url = vodDownloadData?.endpointUrl;

  const dispatch = useTypedDispatch();

  useEffect(() => {
    if (!isViewerInfoFetched) {
      return;
    }
    dispatch(setIsViewerEndExposed(true));
    dispatch(setIsViewerMenuExposed({isExposed: true}));
  }, [dispatch, isViewerInfoFetched]);

  useEffect(() => {
    // DRM 정보를 가져오는데 실패했다면, PagewebError가 아니라 커스텀 IniError를 발생시킵니다.
    if (drmInfo?.error) {
      dispatch(
        setIniError({
          code: IniErrorCode.Custom,
          iniExtendedCode: IniExtendedErrorCode.GetVideoDataFailed,
          message: 'Video data not exist',
          detail: `url : ${url}`,
        })
      );
    }
  }, [dispatch, url, drmInfo?.error]);

  if (!isLoadedIniPlayer) {
    return null;
  }

  return <>{children}</>;
}
